export const THEORY_PAGE_ANCHOR = 'theory-page-content';
